export const CHECKOUT_INFO = '/info';
export const CHECKOUT_DEDUCTIBLE = '/deductible';
export const CHECKOUT_START_DATE = '/start-date';
export const CHECKOUT_CONTACT = '/contact';
export const CHECKOUT_SUMMARY = '/summary';
export const CHECKOUT_CONFIRMATION_BASE = '/confirmation';
